const getHoursFromNow = {
  hours: 'horas restantes',
  minutes: 'min restantes'
};

export default getHoursFromNow;
